module.exports = __webpack_public_path__ + "img/AK0090-DB.63313cad.jpg";